<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Ordenes de compra</span>

  <div class="absolute right-0 content-center">
    <ul class="flex-row flex content-center gap-2">
      <li>
        <button mat-icon-button (click)="openDialogCreate()">
          <mat-icon>add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="fechaCreacion">
        <th mat-header-cell *matHeaderCellDef>Fecha Creación</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fechaCreacion | date: "dd-MM-yyyy" }}
        </td>
      </ng-container>

      <!--         <ng-container matColumnDef="fechaCaducidad">
          <th mat-header-cell *matHeaderCellDef>fechaCaducidad</th>
          <td mat-cell *matCellDef="let element">{{ element.fechaCaducidad  | date: 'dd-MM-yyyy' }}</td>
        </ng-container> -->
<!-- 
      <ng-container matColumnDef="fechaFinalizada">
        <th mat-header-cell *matHeaderCellDef>Fecha Finalizada</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fechaFinalizada | date: "dd-MM-yyyy" }}
        </td>
      </ng-container> -->

      <ng-container matColumnDef="numeroRegistros">
        <th mat-header-cell *matHeaderCellDef>Número Registros</th>
        <td mat-cell *matCellDef="let element">
          {{ element.numeroRegistros }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">
          <label *ngIf="element.estado == 0"> Creada </label>
          <label *ngIf="element.estado == 1"> Presentada </label>
          <label *ngIf="element.estado == 2"> Finalizada </label>
          <label *ngIf="element.estado==3"> Rechazada </label> 
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            *ngIf="element.estado == 0"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="abrirModalDeportistas(element)"
          >
            <mat-icon>recent_actors</mat-icon>
          </button>

          <button
          *ngIf="element.estado == 0"
          [disabled]="element.numeroRegistros==0"
          color="accent"
          mat-icon-button
          aria-label="Edit"
          (click)="enviar(element)"
        >
          <mat-icon>send</mat-icon>
        </button>

          <button
            *ngIf="element.estado != 0"
            color="primary"
            mat-icon-button
            aria-label="abre detalle de la orden de compra enviada"
            (click)="abrirDetalleOrdenCompra(element)"
          >
            <mat-icon>receipt_long</mat-icon>
          </button>

          <button
          *ngIf="element.estado != 0"
          color="primary"
          mat-icon-button
          aria-label="Edit"
          (click)="generarPdf(element)"
        >
          <mat-icon>picture_as_pdf</mat-icon>
        </button>

          <button
            *ngIf="element.estado == 0"
            mat-icon-button
            color="warn"
            aria-label="Delete"
            mat-icon-button
            aria-label="Delete"
            (click)="delete(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>

          <button
            *ngIf="element.estado != 0"
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="getValorOrdenCompraFinal(element)"
          >
            <mat-icon>attach_money</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
